<template>
<defaultLayout :data="data" :page="page" section="matter">
  <template slot-scope="slotProps">
    <div class="matter-container">
      <matter-header />
      <featured-article :article="featuredArticleData" />
      <matter-articles :articles="articlesData" />
    </div>
  </template>
</defaultLayout>
</template>

<script>
import defaultLayout from '@/layouts/default';
import FeaturedArticle from '@/components/matter/FeaturedArticle';
import MatterArticles from '@/components/matter/MatterArticles';
import MatterHeader from '@/components/matter/MatterHeader';

export default {

  name: 'MatterMain',

  metaInfo: {
    title: 'Matter - Particle Design',
  },

  props: ['data', 'page'],

  components: { defaultLayout, FeaturedArticle, MatterArticles, MatterHeader },

  computed: {

    featuredArticleData() {
      return this.data.featured[0] || {};
    },

    articlesData() {
      return this.data.articles || [];
    },

  },
};
</script>


<style lang="scss">
@import '../styles/main.scss';
@import '../styles/_typography.scss';
@import '../styles/_mixins.scss';

.section-matter {

  /*
    this section handles "extended-desktop" mode
    it should be on all "core" pages
  */
  main {
    width: 100%;
    display: grid;
    grid-template-columns: 0 100vw 0;

    @include ngMq($layout--max-content-width, up) {
      grid-template-columns: 1fr $layout--max-content-width 1fr;
    }

    .matter-container {
      grid-column: 2 / span 1;
    }
  }

  footer {
    // & > [data-module],
    & > .matter-featured {
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      grid-gap: rem(24px);
      padding: 0 rem(26px);

      @include ngMq($nbp--tablet, up) {
        grid-template-columns: repeat(12, 1fr);
        grid-gap: rem(26px);
        padding: 0 rem(42px);
      }

      @include ngMq($nbp--desktop, up) {
        grid-gap: rem(37px);
        padding: 0 rem(138px);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/MatterMain.vue